<template>
  <div class="pt" role="tablist" :aria-label="ariaLabel" data-test="pill-tabs">
    <button
      v-for="it in items"
      :key="it.id"
      type="button"
      role="tab"
      class="pt__tab"
      :class="{ 'is-on': it.id === value }"
      :aria-selected="it.id === value ? 'true' : 'false'"
      :data-test="`pill-tab-${it.id}`"
      @click="$emit('change', it.id)"
    >{{ it.label }}<span v-if="it.count !== undefined && it.count !== null" class="pt__count">{{ it.count }}</span></button>
  </div>
</template>

<script>
/**
 * The design's pill switch (Forms | Wiki templates, Text | Email, All | Designed emails | Text
 * templates). `v-model` works: it reads `value` and writes the picked tab's `id` on `change`.
 *
 * Presentational: no store, no mixin. ⛔ No prop named patNum / siteID / loading / allSettings.
 */
export default {
  name: 'PillTabs',

  model: { prop: 'value', event: 'change' },

  props: {
    /** [{ id, label, count? }] */
    items: { type: Array, required: true },
    value: { type: String, default: '' },
    ariaLabel: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@import './action-panel';

.pt {
  display: inline-flex;
  align-self: flex-start;
  max-width: 100%;
  gap: 2px;
  padding: 3px;
  border: 1px solid $pp-line;
  border-radius: $pp-radius;
  background: $pp-bg;
}

.pt__tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  height: 34px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: $pp-ink-3;
  font: inherit;
  font-size: 13.5px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;

  &:hover { color: $pp-ink; }
  &:focus-visible { outline: 2px solid $pp-brand; outline-offset: 1px; }

  &.is-on {
    background: $pp-surface;
    color: $pp-brand-deep;
    box-shadow: $pp-shadow;
  }

  @include ap-touch { height: 44px; }
}

.pt__count {
  font-size: 12px;
  font-weight: 600;
  color: $pp-ink-4;
}
</style>
